import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from 'primereact/button';

export function Forbidden() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const appName = searchParams.get('name') || 'this documentation';

  const userRightsImage = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iI2Y1ZjVmNSIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LXNpemU9IjgwIiBmaWxsPSIjOTk5IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+403CrjwvdGV4dD48L3N2Zz4=';

  return (
    <div style={{ width: '100vw', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#ffffff' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '24px', padding: '24px', maxWidth: '900px', width: '100%', boxSizing: 'border-box' }}>
        <div style={{ flex: '0 0 auto' }}>
          <img src={userRightsImage} alt="Access Denied" style={{ width: '220px', height: 'auto', objectFit: 'contain' }} />
        </div>

        <div style={{ flex: '1 1 auto', display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <div style={{
            fontSize: '28px',
            fontWeight: 700,
            background: 'linear-gradient(90deg, #164293 0%, #0066cc 25%, #006633 50%, #cc0066 75%, #89037a 100%)',
            WebkitBackgroundClip: 'text' as any,
            backgroundClip: 'text',
            color: 'transparent'
          }}>403</div>
          <div style={{ fontSize: '28px', fontWeight: 700, color: '#111' }}>Access Denied</div>
          <div style={{ color: '#444', fontSize: '16px' }}>
            You don't have access to {appName}.
          </div>
          <div style={{ color: '#444', fontSize: '16px' }}>
            This documentation may require specific identity provider credentials or an active subscription.
          </div>
          <div style={{ color: '#444', fontSize: '16px' }}>
            Our <a href="https://www.etas.com/ww/en/support-training/support-hotlines/" target="_blank" rel="noopener noreferrer" style={{ color: '#164293', textDecoration: 'underline' }}>customer support</a> team is ready to help.
          </div>

          <div style={{ marginTop: '16px', display: 'flex', gap: '12px', justifyContent: 'flex-start' }}>
            <Button label="Go to Catalog" onClick={() => navigate('/')} />
          </div>
        </div>
      </div>
    </div>
  );
}
